<script>
  export let isLoading = false;
</script>

{#if isLoading}
  <div class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
  </div>
{/if}

<style>
  .loading-overlay {
    position: fixed; inset: 0; background: rgba(255,255,255,0.6);
    display: flex; align-items: center; justify-content: center; z-index: 9998;
  }
</style>
